import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import specialOffersService from '../../services/specialOffers';

const initialState = {
  loading: false,
  list: [],
  error: '',
  params: { page: 1, perPage: 10 },
  meta: {},
};

export const fetchSpecialOffers = createAsyncThunk(
  'specialOffers/fetchSpecialOffers',
  (params = {}) =>
    specialOffersService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res),
);

const specialOffersSlice = createSlice({
  name: 'specialOffers',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSpecialOffers.fulfilled, (state, action) => {
        const payload = action.payload;
        const meta = payload?.meta ?? {};
        state.loading = false;
        state.list = Array.isArray(payload?.data) ? payload.data : [];
        state.meta = meta;
        state.params.page = meta.current_page ?? state.params.page;
        state.params.perPage = meta.per_page ?? state.params.perPage;
        state.error = '';
      })
      .addCase(fetchSpecialOffers.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.error?.message ?? '';
      });
  },
});

export default specialOffersSlice.reducer;
